export default {"src":"/_next/static/media/googleplay.670d51ed.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};